import React from "react";
import { useTranslation } from "react-i18next";

import * as sc from "./styles";

const SearchClaims = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <sc.SearchClaims>
      <sc.TermsLink onClick={onClick}>{t("Terms and Conditions")}</sc.TermsLink>
      <sc.PoweredBy>Powered by Shutterstock</sc.PoweredBy>
    </sc.SearchClaims>
  );
};

export default SearchClaims;
